import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme, Theme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography, useMediaQuery } from '@mui/material';

// project imports
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from '../NetflixLayout/Header';
import navigation from 'menu-items';
import { drawerWidth } from 'store/constant';
import PollIcon from '@mui/icons-material/Poll';
import { SET_MENU } from 'store/actions';
import { DefaultRootStateProps } from 'types';

// assets
import { IconChevronRight } from '@tabler/icons';
import RedQuickScrollDialog from 'components/RedQuickScrollDialog';

interface MainStyleProps {
    theme: Theme;
    open: boolean;
}

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }: MainStyleProps) => ({
    ...theme.typography.mainContent,
    ...({
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        marginTop: 0,
        marginLeft: 0,
        width: '100%',
        overflow: 'hidden',
        padding: 0,
        marginRight: 0
    })
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const customization = useSelector((state: DefaultRootStateProps) => state.customization);
    const POPUP_CONSTANT = 'playwatch-newsletter-popup';
    // Handle left drawer
    const leftDrawerOpened = false;
    const dispatch = useDispatch();
    const bigstyle = { fontSize: 50, lineHeight: `50px` };
    const mediumstyle = { fontSize: 32, lineHeight: `35px` };
    const smallstyle = { fontSize: 16, lineHeight: `35px` };
    React.useEffect(() => {
        dispatch({
            type: SET_MENU,
            opened: !matchDownMd
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);
    React.useEffect(() => {
        let hasOpened = localStorage.getItem(POPUP_CONSTANT)
        if (!hasOpened) {
            setDialogOpen(true);
        }
    }, [])

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            {/* header */}
            <AppBar
                enableColorOnDark
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: 'transparent',
                    transition: leftDrawerOpened ? theme.transitions.create('width') : 'none',
                    backgroundImage: 'linear-gradient(to bottom,rgba(0,0,0,.7) 10%,rgba(0,0,0,0))',
                    [theme.breakpoints.down('md')]: {
                        // width: 'auto'
                    }
                }}
            >
                <Toolbar>
                    <Header handleLeftDrawerToggle={() => {
                        console.log('no drawer')
                    }} />
                </Toolbar>
            </AppBar>
            {/* main content */}
            <Main theme={theme} open={false}>
                {/* breadcrumb */}
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                <div style={{ paddingTop: 88 }}>
                    <Outlet />
                </div>
            </Main>
        </Box>
    );
};

export default MainLayout;
